import React from 'react';
import Image from '@base/lib/ThemeImage';
import siteConf from 'pro/config/site';
import { RouteEnum } from 'pro/config/routers';

export type ILogoType = 'black' | 'white' | 'primary'
type IProps = {
    logoType?: ILogoType,
    canJump?: boolean;
    width?: number;
    height?: number;
}

const logoSrc = {
    black: 'asset/width-9168/picture/b6b1e7c085665d684a721c0e023103bb.png',
    white: 'file-asset/file/6b931043eca6dae807d325dd58d2d76a.svg',
    primary: 'file-asset/file/16d2e8a25c5a9cf524dbfb8e4800217b.svg'
}

const HeaderLogo: React.FC<IProps> = (props) => {
    const {
        logoType = 'black',
        canJump = true,
        width = 180,
        height = 33
    } = props

    return (
        <Image
            href={canJump ? RouteEnum.SHOP : void 0}
            src={logoSrc[logoType]}
            alt={siteConf.brand}
            width={width}
            height={height}
            background={false}
            fixed
        />
    )
};

export default HeaderLogo;